var styles = {"footer":"styles_footer__jBEM2","noSpacing":"styles_no-spacing__jBpp-","compactSpacing":"styles_compact-spacing__R68Jg","comfortableSpacing":"styles_comfortable-spacing__euml0","looseSpacing":"styles_loose-spacing__XAeJN"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
